import React from 'react';
import Hero from '../components/home/Hero';
import Collections from '../components/home/Collections';
import WhatWeDo from '../components/home/WhatWeDo';
import HowToOrder from '../components/home/HowToOrder';
import Testimonials from '../components/home/Testimonials';

const Home = () => {
    return (
        <div>
            <Hero />
            <Collections />
            <WhatWeDo />
            <HowToOrder />
            <Testimonials />
        </div>
    );
};

export default Home;